<td colspan="100%">
  <table class="table table-hover admin-data-table__sub-table">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th *ngFor="let column of _columnConfig">
          <span
            class="sortable"
            [class.sort]="sort == column.key"
            [class.up]="sortDir == 'ASC'"
            [class.down]="sortDir == 'DESC'"
            (click)="sortHeaderItems(column.key)"
          >
            {{ column.title }}
          </span>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of header.items">
        <td class="align-center">
          <label class="checkbox-style" *ngIf="item.isMatch">
            <input
              class="checkbox"
              *ngIf="withRowCheckBoxes"
              type="checkbox"
              (change)="markSelected(header, item)"
              [checked]="item.checked"
            />
            <span class="checkmark"></span>
          </label>
        </td>
        <td *ngFor="let column of _columnConfig" class="cell-icons">
          <span>
            <ng-container *ngIf="column.key === 'action'; else showData">
              <ul class="dropdown">
                <li dropdown dropdownToggle>
                  <button class="icon icon-kog"></button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="angular-simple-dropdown"
                  >
                    <li (click)="column.action(item, 'runItem')">
                      View/Edit
                    </li>
                  </ul>
                </li>
              </ul>
            </ng-container>
            <ng-template #showData>
              {{ item[column.key] | cellcontent: column.type }}
              {{ column.meta ? "(" + item[column.meta] + ")" : null }}
            </ng-template>
          </span>
        </td>
        <td></td>
      </tr>
    </tbody>
  </table>
</td>
